import React from 'react';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { GiFairyWings } from 'react-icons/gi'; 
import './AdvisoryBoard.css';

import trustee1 from '../../../assets/home/onkar-singh.jpg';
import trustee2 from '../../../assets/home/shiv-ji-singh.jpg';
import trustee3 from '../../../assets/home/ummedsingh.jpg';
import trustee4 from '../../../assets/home/arjunsinghji.jpg';

const trusteesData = [
  { id: 1, name: "Thakur Onkar Singh Babra IAS(Retd.)", post: "Trustee, Rajput Shiksha Kosh.", img: trustee1 },
  { id: 2, name: "Col. Shivji Singh", post: "Trustee, Rajput Shiksha Kosh.", img: trustee2 },
  { id: 3, name: "Col. Ummed Singh Rathore", post: "Trustee, Rajput Shiksha Kosh.", img: trustee3 },
  { id: 4, name: "Shri Arjun Singh Jhotra", post: "Trustee, Rajput Shiksha Kosh.", img: trustee4 },
];

const AdvisoryBoard = () => {
  return (
    <section className="advisory-board-component-section">
      <div className="advisory-board-component-container">
        
        {/* --- HEADER & DIVIDER --- */}
        <div className="advisory-board-component-header">
          <h2 className="advisory-board-component-title">Advisory Board -Rajput Shiksha Kosh</h2>
          <div className="advisory-board-component-divider">
            <span className="advisory-board-component-line"></span>
            <GiFairyWings className="advisory-board-component-icon" />
            <span className="advisory-board-component-line"></span>
          </div>
        </div>

        {/* --- TRUSTEE GRID --- */}
        <div className="advisory-board-component-grid">
          {trusteesData.map((trustee) => (
            <div className="advisory-board-component-card" key={trustee.id}>
              
              <div className="advisory-board-component-img-wrapper">
                <img 
                  src={trustee.img} 
                  alt={trustee.name} 
                  className="advisory-board-component-img" 
                />
              </div>

              <div className="advisory-board-component-info">
                <h3 className="advisory-board-component-name">{trustee.name}</h3>
                <p className="advisory-board-component-post">{trustee.post}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AdvisoryBoard;